import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../utils/cn';
import { TONE_CLASSES, type Tone } from './toneStyles';

export type BadgeTone = Tone;

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
    tone?: BadgeTone;
}

const BASE_CLASSES = 'inline-flex items-center rounded-full px-2 py-0.5 text-micro font-bold';

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
    { tone = 'neutral', className, children, ...rest },
    ref,
) {
    return (
        <span
            ref={ref}
            className={cn(BASE_CLASSES, TONE_CLASSES[tone].bg, TONE_CLASSES[tone].text, className)}
            {...rest}
        >
            {children}
        </span>
    );
});

export default Badge;
